import React from "react";

interface HeaderProps {
  eventCount: number;
  creditsRemaining: number;
  creditsUsed: number;
  userEmail?: string;
  onLogout?: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  eventCount,
  creditsRemaining,
  creditsUsed,
  userEmail,
  onLogout,
}) => {
  return (
    <header
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        background: "rgba(5, 5, 5, 0.85)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-8 h-14 flex items-center justify-between gap-4">

        {/* Logo */}
        <div className="flex items-center gap-3 shrink-0">
          <span
            style={{
              fontFamily: "'Syne', sans-serif",
              fontWeight: 800,
              fontSize: "1.0625rem",
              letterSpacing: "-0.03em",
              color: "#fafafa",
            }}
          >
            SENÁT
          </span>
          <span
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: 300,
              fontSize: "0.6875rem",
              letterSpacing: "0.08em",
              color: "#666666",
              paddingTop: "1px",
            }}
          >
            monitoring
          </span>
        </div>

        {/* Right side — event count + credits + logout */}
        <div className="flex items-center gap-3 shrink-0">
          {/* Event count */}
          <span
            className="hidden sm:inline"
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: 300,
              fontSize: "0.8125rem",
              color: "#666666",
            }}
          >
            {eventCount} akcí
          </span>

          {/* Credits pill */}
          <div
            className="flex items-center gap-1.5 px-3 py-1"
            style={{
              background: "rgba(255, 255, 255, 0.06)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              borderRadius: "999px",
              backdropFilter: "blur(8px)",
              WebkitBackdropFilter: "blur(8px)",
            }}
          >
            <span
              style={{
                fontFamily: "'Syne', sans-serif",
                fontWeight: 700,
                fontSize: "0.8125rem",
                color: "#fafafa",
                letterSpacing: "-0.01em",
              }}
            >
              {creditsRemaining}
            </span>
            <span className="eyebrow-label" style={{ marginBottom: 0 }}>
              kr
            </span>
          </div>

          {/* Logout */}
          {userEmail && (
            <button
              onClick={onLogout}
              className="btn-glow hidden sm:flex"
              style={{ fontSize: "0.75rem", padding: "0.375rem 0.75rem" }}
              title={userEmail}
            >
              Odhlásit
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
